import axiosInstance from '../../config/AxiosConfig'
import {BACKEND_ENDPOINT} from '../../Constants'

const STATISTIC_PATH = 'statistics'

export function getActiveDeviceByGender() {
    return axiosInstance
        .post(
            `${BACKEND_ENDPOINT}/${STATISTIC_PATH}/getDeviceActiveByUser`,
            null,
        )
        .then(res => res.data)
        .catch(error => console.log(error))
}

export function getUserStatistics(userId, hospitalId, year) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/${STATISTIC_PATH}/getUserStatistics`, null, {
            params: {
                userId,
                hospitalId,
                year,
            },
        })
        .then(res => res.data)
        .catch(error => console.log(error))
}
